var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission-empty"},[_c('i',{staticClass:"el-icon-lock"}),_c('h2',[_vm._v("暂无访问权限")]),_c('p',[_vm._v("当前账号尚未获得此页面的权限，请联系主账号管理员分配角色。")]),_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.refresh}},[_vm._v("刷新权限")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }